import './AuthLayout.css'

/**
 * Shell shared by Login, Signup, OTP and Activate.
 *
 * Both of the legacy's images are here, doing the jobs the legacy gives them:
 * `Login-background.jpg` fills the page, and `login-side-ar.png` is a column at
 * the reading-start edge. The port had been showing only the side artwork over
 * a pale gradient, so the card sat white-on-white with nothing behind it — the
 * background is what gives the sheet something to float above.
 *
 * The culture switch lives on the card (AuthHead), not out here: a control
 * floating over the background sits outside the only object on the page that
 * takes input, and on a phone — where the artwork is hidden — it was alone on
 * an empty field.
 */
export default function AuthLayout({ children }) {
  return (
    <div className="auth">
      {/* The legacy side artwork, shown exactly as authored — no overlay,
          gradient, tint, filter or blend mode over it. */}
      <aside className="auth__brand" aria-hidden="true" />

      <main className="auth__panel">{children}</main>
    </div>
  )
}
